import React from "react";
import { Link } from "react-router-dom";
import { Instagram, MapPin, Phone, Clock } from "lucide-react";

const TikTokIcon = (props) => (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" {...props}>
    <path d="M12.84.02h3.34a6.69 6.69 0 0 0 4.84 5.97v3.34a9.95 9.95 0 0 1-4.84-1.36v7.06a7.36 7.36 0 1 1-7.36-7.37c.21 0 .42.02.62.05v3.4a3.97 3.97 0 1 0 3.4 3.92V.02Z" />
  </svg>
);

const Footer = () => {
  return (
    <footer data-testid="lf-footer" className="relative mt-12" style={{ background: "var(--lf-cream-2)", borderTop: "1px solid var(--lf-border)" }}>
      <div className="lf-container py-20 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <div className="font-serif text-5xl md:text-6xl italic leading-none" style={{ color: "var(--lf-gold-deep)", fontWeight: 500 }}>
            La Fleur
          </div>
          <p className="font-script text-2xl mt-2" style={{ color: "var(--lf-pink-deep)" }}>
            Luxury in every bloom.
          </p>
          <p className="mt-5 text-sm leading-relaxed max-w-md" style={{ color: "var(--lf-ink-soft)" }}>
            A boutique flower shop in the heart of Graham, North Carolina. Bouquets, balloons, sweets, and gifts — designed with quiet luxury for every moment.
          </p>
          <div className="mt-8 flex items-center gap-5">
            <a data-testid="footer-instagram" href="https://instagram.com/la_fleur_floreria" target="_blank" rel="noreferrer"
               className="flex items-center gap-2 lf-link" style={{ letterSpacing: "0.08em", textTransform: "none" }}>
              <Instagram size={18} strokeWidth={1.5} />
              <span className="text-sm">@la_fleur_floreria</span>
            </a>
            <a data-testid="footer-tiktok" href="https://tiktok.com/@la_fleur_floreria" target="_blank" rel="noreferrer"
               className="flex items-center gap-2 lf-link" style={{ letterSpacing: "0.08em", textTransform: "none" }}>
              <TikTokIcon />
              <span className="text-sm">TikTok</span>
            </a>
          </div>
        </div>

        <div className="md:col-span-3">
          <div className="lf-eyebrow">Visit</div>
          <div className="mt-5 flex items-start gap-3 text-sm">
            <MapPin size={16} strokeWidth={1.5} className="mt-1 flex-shrink-0" style={{ color: "var(--lf-gold-deep)" }} />
            <p className="leading-relaxed" data-testid="footer-address">116 South Main St<br />Graham, NC</p>
          </div>
          <div className="mt-4 flex items-start gap-3 text-sm">
            <Phone size={16} strokeWidth={1.5} className="mt-1 flex-shrink-0" style={{ color: "var(--lf-gold-deep)" }} />
            <a href="tel:+13362690356" data-testid="footer-phone" className="hover:text-[var(--lf-gold-deep)] transition-colors">(336) 269-0356</a>
          </div>
          <div className="mt-4 flex items-start gap-3 text-sm" style={{ color: "var(--lf-ink-soft)" }}>
            <Clock size={16} strokeWidth={1.5} className="mt-1 flex-shrink-0" style={{ color: "var(--lf-gold-deep)" }} />
            <p className="leading-relaxed">Mon – Fri · 10a – 6p<br />Sat · 10a – 4p · Sun · Closed</p>
          </div>
        </div>

        <div className="md:col-span-4">
          <div className="lf-eyebrow">Explore</div>
          <div className="mt-5 grid grid-cols-2 gap-3 text-sm">
            <Link to="/shop?category=bouquets" className="hover:text-[var(--lf-gold-deep)] transition-colors">Bouquets</Link>
            <Link to="/shop?category=balloons" className="hover:text-[var(--lf-gold-deep)] transition-colors">Balloons</Link>
            <Link to="/shop?category=sweets" className="hover:text-[var(--lf-gold-deep)] transition-colors">Sweets</Link>
            <Link to="/shop?category=merch" className="hover:text-[var(--lf-gold-deep)] transition-colors">Merch</Link>
            <Link to="/shop?category=gifts" className="hover:text-[var(--lf-gold-deep)] transition-colors">Gifts</Link>
            <Link to="/services/flower-bar" className="hover:text-[var(--lf-gold-deep)] transition-colors">Flower Bar</Link>
            <Link to="/services/bridal" className="hover:text-[var(--lf-gold-deep)] transition-colors">Bridal</Link>
            <Link to="/services/memorial" className="hover:text-[var(--lf-gold-deep)] transition-colors">Memorial</Link>
            <Link to="/services/supplies" className="hover:text-[var(--lf-gold-deep)] transition-colors">Wholesale Supplies</Link>
            <Link to="/about" className="hover:text-[var(--lf-gold-deep)] transition-colors">About & Contact</Link>
          </div>
        </div>
      </div>

      <div className="border-t py-6 lf-container flex flex-col md:flex-row gap-3 justify-between items-center text-xs"
           style={{ borderColor: "var(--lf-border)", color: "var(--lf-ink-soft)" }}>
        <span>© {new Date().getFullYear()} La Fleur Flower Shop · Luxury in every bloom.</span>
        <span style={{ letterSpacing: "0.2em", textTransform: "uppercase" }}>Same-day delivery · Pickup available</span>
      </div>
    </footer>
  );
};

export default Footer;
